// Color theme for the app - cohesive purple/blue gradient scheme
export const theme = {
  colors: {
    primary: '#6366f1', // Indigo
    primaryDark: '#4f46e5',
    primaryLight: '#818cf8',
    secondary: '#8b5cf6', // Purple
    secondaryDark: '#7c3aed',
    secondaryLight: '#a78bfa',
    accent: '#ec4899', // Pink accent
    background: '#f8fafc',
    surface: '#ffffff',
    text: '#1e293b',
    textLight: '#64748b',
    textMuted: '#94a3b8',
    border: '#e2e8f0',
    userMessage: '#6366f1',
    botMessage: '#f1f5f9',
    error: '#ef4444',
    success: '#10b981',
  },
  gradients: {
    primary: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #ec4899 100%)',
    header: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
    subtle: 'linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)',
  },
  shadows: {
    sm: '0 1px 2px rgba(99, 102, 241, 0.1)',
    md: '0 4px 6px rgba(99, 102, 241, 0.1)',
    lg: '0 10px 15px rgba(99, 102, 241, 0.1)',
  },
};

